import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import smallButton from 'assets/images/handles/doors/small_button.jpg';
import bigButton from 'assets/images/handles/doors/big_button.png';
import BigOptionButton from 'components/BigOptionButton';
import {
  selectPaintDoorHandleAction,
  updateHandleDoorAction,
} from 'containers/HandlesPanel/actions';
import {
  ALUMINIUM_COLOR,
  DoorHandleType,
  DrawerHandleType,
} from 'lib/modelBuilder/constants';
import { useTranslation } from 'react-i18next';
import useMedia from 'use-media';
import { PickerTitleCategory } from '../../components/PickerTitleCategory';
import { ConfiguratorMode, HandlesMode } from '../ModeBar/reducer';
import {
  makeSelectConfiguratorMode,
  makeSelectPaintHandlesMode,
} from '../ModeBar/selectors';
import { findColor } from '../../lib/modelBuilder/utils/colorHelper';
import { makeSelectPaintTypeHandles } from './selectors';
import { Color } from '../../lib/modelBuilder/entities/Color';

// import styled from 'styled-components/macro';

interface StateProps {
  lastHistoryCabinet: Cabinet;
  mode: ConfiguratorMode;
  handlesMode: HandlesMode;
  paintType: DoorHandleType | DrawerHandleType | undefined;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
  mode: makeSelectConfiguratorMode(),
  handlesMode: makeSelectPaintHandlesMode(),
  paintType: makeSelectPaintTypeHandles(),
});

const ButtonTypePicker = () => {
  const dispatch = useDispatch();
  const { lastHistoryCabinet, mode, handlesMode, paintType } = useSelector(
    stateSelector,
  );
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });

  const onLeave = () => {
    // Restore the last history element
    if (mode === ConfiguratorMode.selector)
      dispatch(restoreCabinet(lastHistoryCabinet));
  };

  let activeBtn: DoorHandleType | undefined = undefined;
  if (
    mode === ConfiguratorMode.handles &&
    handlesMode === HandlesMode.doors &&
    (paintType === DoorHandleType.Button ||
      paintType === DoorHandleType.BigButton)
  ) {
    if (paintType === DoorHandleType.Button) activeBtn = DoorHandleType.Button;
    else if (paintType === DoorHandleType.BigButton)
      activeBtn = DoorHandleType.BigButton;
  }

  return (
    <div className="mx-2 bg-white lg:w-56">
      {!isMobile && (
        <div className="flex bg-gray-300">
          <PickerTitleCategory selected onClick={() => {}}>
            {t('Buttons')}
          </PickerTitleCategory>
        </div>
      )}

      <div className="h-24">
        <div className="flex my-2 mx-0">
          <BigOptionButton
            imgSrc={smallButton}
            title={t('Small button')}
            handleClick={() => {
              if (mode === ConfiguratorMode.selector)
                dispatch(updateHandleDoorAction(DoorHandleType.Button));
              else {
                dispatch(
                  selectPaintDoorHandleAction(
                    DoorHandleType.Button,
                    findColor(ALUMINIUM_COLOR),
                  ),
                );
              }
            }}
            handleHover={() => {
              if (mode === ConfiguratorMode.selector)
                dispatch(
                  updateHandleDoorAction(
                    DoorHandleType.Button,
                    undefined,
                    undefined,
                    true,
                  ),
                );
            }}
            onLeave={onLeave}
            selected={activeBtn === DoorHandleType.Button}
          />
          <BigOptionButton
            imgSrc={bigButton}
            title={t('Big button')}
            handleClick={() => {
              if (mode === ConfiguratorMode.selector)
                dispatch(updateHandleDoorAction(DoorHandleType.BigButton));
              else {
                dispatch(
                  selectPaintDoorHandleAction(
                    DoorHandleType.BigButton,
                    findColor(ALUMINIUM_COLOR),
                  ),
                );
              }
            }}
            handleHover={() => {
              if (mode === ConfiguratorMode.selector)
                dispatch(
                  updateHandleDoorAction(
                    DoorHandleType.BigButton,
                    undefined,
                    undefined,
                    true,
                  ),
                );
            }}
            onLeave={onLeave}
            selected={activeBtn === DoorHandleType.BigButton}
          />
        </div>
      </div>
    </div>
  );
};

export default ButtonTypePicker;
